"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAutocompleteSource = void 0;
const react_1 = require("react");
const crud_source_hook_1 = require("../../../utils/crud-source-hook");
const event_callback_hook_1 = require("../../../utils/event-callback-hook");
const scrollable_source_hook_1 = require("../../../utils/scrollable-source-hook");
function useAutocompleteSource({ url, apiUrl, params, }) {
    const loadDetail = (0, event_callback_hook_1.useEventCallback)(async (item) => {
        if (apiUrl !== undefined) {
            const fetch = (0, crud_source_hook_1.defaultGetItem)(apiUrl, item.id);
            const detail = await fetch.json();
            return detail;
        }
        return Promise.resolve(item);
    });
    const source = (0, scrollable_source_hook_1.useScrollableSource)({
        url,
        params,
    });
    const setSearchQuery = (0, event_callback_hook_1.useEventCallback)((q) => {
        source.setUrl(`${url}?query=${encodeURIComponent(q)}`);
    });
    return (0, react_1.useMemo)(() => ({
        ...source,
        setSearchQuery,
        loadDetail,
    }), [source, setSearchQuery, loadDetail]);
}
exports.useAutocompleteSource = useAutocompleteSource;
//# sourceMappingURL=autocomplete-source-hook.js.map